module.exports = __webpack_public_path__ + "static/media/1992-Impreza-GF.2869cb4e.webp";